import React from 'react';
import Radium from 'radium';
import { FieldArray, reduxForm } from 'redux-form';
import { string, func, bool } from 'prop-types';
import { UTButton, WithLoading } from '@widergy/energy-ui';

import { CHANGE_USER_INFO } from 'constants/reduxForms';
import { message } from 'utils/stringUtils';
import { appConfig } from 'config/customization';
import { passwordField } from 'constants/fields';
import UTForm from 'app/components/UTForm';

import Phones from './components/Phones';
import Emails from './components/Emails';
import stylesJS from './styles';
import styles from './styles.module.scss';

const fields = [passwordField];

const ChangeUserInfo = ({
  onSetDefaultPhone,
  defaultPhoneNumber,
  onSubmitForm,
  submitFailed,
  invalid,
  onGoToDashboard
}) => (
  <React.Fragment>
    <FieldArray
      name="phones"
      component={Phones}
      onSetDefaultPhone={onSetDefaultPhone}
      defaultPhoneNumber={defaultPhoneNumber}
    />
    <FieldArray
      name="mobiles"
      isMobile
      component={Phones}
      onSetDefaultPhone={onSetDefaultPhone}
      defaultPhoneNumber={defaultPhoneNumber}
    />
    {appConfig.userDataManagement.shouldUpdateEmail && <FieldArray name="emails" component={Emails} />}
    {appConfig.userDataManagement.requirePasswordForUserDataManagement && (
      <div style={stylesJS.password}>
        <UTForm fields={fields} />
      </div>
    )}
    <div style={stylesJS.actionButtonsContainer}>
      <UTButton secondary className={styles.cancelButton} onPress={onGoToDashboard}>
        {message('Commons:cancel')}
      </UTButton>
      <UTButton disabled={submitFailed && invalid} onPress={onSubmitForm}>
        {message('Configuration:saveButton')}
      </UTButton>
    </div>
  </React.Fragment>
);

ChangeUserInfo.propTypes = {
  onSetDefaultPhone: func.isRequired,
  onSubmitForm: func.isRequired,
  defaultPhoneNumber: string,
  submitFailed: bool,
  invalid: bool,
  onGoToDashboard: func
};

export default WithLoading(props => props.loading)(
  reduxForm({ form: CHANGE_USER_INFO })(Radium(ChangeUserInfo))
);
